import React from 'react';

import logoLogOut from 'Components/Admin/assets/log-out.svg';
import logoLogOutMobile from 'Components/Admin/assets/log-out-mobile.svg';
import TriangleIcon from 'Components/Admin/TriangleIcon/TriangleIcon';
import DropdownMenu from 'Components/Admin/DropdownMenu';

function Loguot() {
  return (
    <div className="admin-page__header__logout-wrapper">
      <DropdownMenu
        binding="bottom"
        triggerButtonRender={(isOpen) => (
          <>
            <div className="admin-page__header__logout">
              <span>Profile</span>
              <TriangleIcon direction={isOpen ? 'up' : 'down'} />
            </div>
            <div className="admin-page__header__logout-mobile">
              <img src={logoLogOutMobile} alt="log out mobile" />
            </div>
          </>
        )}
      >
        <li>
          <button>
            <img src={logoLogOut} alt="log out" />
            <span>Log out</span>
          </button>
        </li>
      </DropdownMenu>
    </div>
  );
}

export default Loguot;
